<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.EDIT') }}
            {{ $t('ABO_SERVICES.ITEM') }}
          </span>
        </v-toolbar-title>

        <v-spacer />

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>

        <v-btn
          class="ml-2"
          color="primary"
          @click="
            $router.push({
              name: 'abo-services.edit',
              params: { id: id }
            })
          "
        >
          {{ $t('BUTTON.EDIT') }}
        </v-btn>
      </v-toolbar>
      <v-divider />
    </v-card>
    <v-card class="mt-3">
      <v-card-text>
        <abo-services-form
          v-model="form"
          :errors="errors.getAll()"
          readonly
          :action="action"
          @update-prop="clearErrorByName($event)"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import AboServicesForm from '@/modules/abo_services/components/AboServicesForm';
import { AboServicesService } from '@/services/abo-services.service';
import { SHOW } from '@/modules/_global/mixins/form-editable';

export default {
  name: 'AboServiceEditPage',

  components: {
    AboServicesForm
  },

  mixins: [errors],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => {
    return {
      valid: {},
      action: SHOW,
      form: {
        translations: [],
        status_id: null,
        title: null
      }
    };
  },

  created() {
    AboServicesService.getById(this.id).then(data => (this.form = data.data));
  },

  methods: {}
};
</script>
